import { gql } from "@apollo/client";
import { useSuspenseQuery } from "@apollo/client/react";

import Brand from "./Brand.graphql";

interface IBrand {
    id: string

    productLines: {
        id: string

        key: string
        name: {
            language: string
            text: string
        }[]
        position: number
    }[]
}

export default function useBrand(id: string) {
    return useSuspenseQuery<{ brand: IBrand }>(
        gql(Brand),
        {
            variables: {
                id,
            },
        },
    );
}
